<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
/*
 * Edit Time
 */
export default {
  page: {
    title: "Edit Time",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      name: "Edit Time",
      title: "Edit Time",
      items: [
        {
          text: "Time Slots",
          href: "/time-slot",
        },
      ],
      form: {
        name: "",
        start_time: "",
        end_time: "",
        days: [],
      },
      errors: null,
      submitted: false,
      pending: false,
      daysList: [
        {
          name: "Saturday",
        },
        {
          name: "Sunday",
        },
        {
          name: "Monday",
        },
        {
          name: "Tuesday",
        },
        {
          name: "Wednesday",
        },
        {
          name: "Thursday",
        },
        {
          name: "Friday",
        },
      ],
      currrentTimeSlot: {},
      authUser: {},
    };
  },
  methods: {
    async getCurrentTimeSlot() {
      let that = this;
      let selected = [];
      await axios
        .get(appConfig.time_slots.edit + this.$route.params.id)
        .then(function (response) {
          that.currrentTimeSlot = response.data.slot;
          that.currrentTimeSlot["days"] = response.data.slot.days;
          that.form = that.currrentTimeSlot;
          selected = that.currrentTimeSlot["days"].split(",");
          for (let x = 0; x < selected.length; x++) {
            Object.keys(selected).forEach(function (x) {
              if (selected[x] === "false") {
                delete selected[x];
              }
            });
            that.currrentTimeSlot["days"] = selected[x];
          }
          that.form.days = selected;
          console.log("form", that.form);
        });
    },
    async updateTimeSlot() {
      let that = this;
      that.submitted = true;
      let formData = new FormData();

      formData.append("name", that.form.name);
      formData.append("start_time", that.form.start_time);
      formData.append("end_time", that.form.end_time);
      formData.append("days", that.form.days);
      formData.append("_method", "put");

      await axios
        .post(appConfig.time_slots.edit + that.$route.params.id, formData, that.headers)
        .then(function (res) {
          console.log(res);
          that.submitted = false;
          that.$iziToast.success({
            message: "Update Successfully!",
            position: "bottomCenter",
          });
          console.log("response2", res);
          that.$router.push({ path: "/time-slot" });
        })
        .catch(function (error) {
          that.submitted = false;
          if (error.response) {
            that.errors = error.response.data.errors;
          }
        });
    },
  },
  created() {
    this.authUser = this.$store.getters["auth/user"];
    this.pending = true;
    axios.all([this.getCurrentTimeSlot()]).finally(() => (this.pending = false));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation" @submit.prevent="updateTimeSlot">
              <fieldset :disabled="submitted || pending">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- Name -->
                    <div class="form-group mb-3">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        id="name"
                        placeholder="Enter name"
                      />
                    </div>
                    <!-- Start Time -->
                    <div class="form-group mb-3">
                      <b-form-group
                        id="label-date-time"
                        label-cols-sm="12"
                        label-cols-lg="12"
                        label="Start Time"
                        label-for="start-date-time"
                      >
                        <b-form-input
                          id="start-date-time"
                          value="2019-08-19T13:45:00"
                          type="time"
                          v-model="form.start_time"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <!-- End Time -->
                    <div class="form-group mb-3">
                      <div class="form-group mb-3">
                        <b-form-group
                          id="label-end-date-time"
                          label-cols-sm="12"
                          label-cols-lg="12"
                          label="End Time"
                          label-for="end-date-time"
                        >
                          <b-form-input
                            id="end-date-time"
                            value="2019-08-19T13:45:00"
                            type="time"
                            v-model="form.end_time"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <!-- Days Availabilty -->
                    <div class="form-group mb-3 daysAvaliablity">
                      <h6 class="mt-0"><strong>Days Availabilty</strong></h6>
                      <div class="row">
                        <div
                          v-for="(day, index) in daysList"
                          :key="index"
                          class="col-sm-6 custom-control custom-checkbox"
                          :checked="form.days.length === daysList.length"
                        >
                          <input
                            v-model="form.days"
                            type="checkbox"
                            class="custom-control-input"
                            :value="day.name"
                            :id="day.name"
                          />
                          <label class="custom-control-label" :for="day.name">
                            {{ day.name }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 mt-4 text-right">
                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                  >
                    <span
                      v-show="submitted || pending"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-show="!submitted && !pending">Update</span>
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.permissions .custom-control-label {
  text-transform: capitalize;
}
.permissions .custom-checkbox {
  display: inline-block;
}
</style>
